import React from 'react'
import {AppPageContainer} from 'views/Containers'
import List from 'components/List'
import {Row, Col} from 'components/Display'
import requiresLoggedIn from 'views/hoc/loggedIn'
import services from 'services'
import ProblemItem from 'components/ProblemItem'
import ProblemContent from 'views/Problems/ProblemContent'
import ProjectContext from 'views/hoc/ProjectContext'
import Spinner from 'components/Spinner'
import AddProblem from './AddProblem'
import {useLocation, Switch, Route} from 'react-router-dom'
import {RouteMatch} from 'data/types'

type ProblemsViewProps = {
  match: RouteMatch<{projectId: string}>
}

function ProblemsView(props: ProblemsViewProps) {
  const problemService = services.getProblemService(props.match.params.projectId)
  const projectService = services.getProjectService(props.match.params.projectId)
  const location = useLocation()
  const selectedProblemId = services.router.getSelectedProblemId(location.pathname)
  const [problems] = problemService.problems.hook()
  const [project] = projectService.project.hook()
  const isSidePanelOpen = selectedProblemId != null

  return (
    <AppPageContainer>
      <ProjectContext>
        {(context) => {
          if (context.isLoading) {
            return (
              <Col className="flex-1 justify-center items-center">
                <Spinner />
              </Col>
            )
          }

          return (
            <Row className="flex-1 h-screen bg-white">
              <Col className="flex-1 border-r">
                <Row className={`${isSidePanelOpen ? 'mx-10' : 'mx-64'} pt-12 mb-8 bg-white justify-between`}>
                  <ProjectContext.Selector context={context} />
                  {project != null && <AddProblem project={project} />}
                </Row>
                <Col className="flex-1">
                  <List estimatedRowHeight={100} items={problems} loadMore={problemService.hasMore ? problemService.load : null}>
                    {(item) => {
                      return (
                        <ProblemItem
                          isFirstItem={item.index === 0}
                          problem={item.data}
                          isSelected={selectedProblemId === item.data.id.toString()}
                          select={() => services.router.selectProblem(item.data)}
                          deselect={() => services.router.selectProject(item.data.projectId)}
                          isSidePanelOpen={isSidePanelOpen}
                        />
                      )
                    }}
                  </List>
                </Col>
              </Col>
              <Col className={`flex-1 ${isSidePanelOpen ? 'visible' : 'hidden'}`}>
                <Switch>
                  <Route
                    path="/projects/:projectId/problems/:problemId"
                    render={(componentProps) => (
                      <ProblemContent deselect={() => services.router.selectProject(props.match.params.projectId)} {...componentProps} />
                    )}
                  />
                </Switch>
              </Col>
            </Row>
          )
        }}
      </ProjectContext>
    </AppPageContainer>
  )
}

export default requiresLoggedIn(ProblemsView)
